export enum ResidentUserType {
  MEMBER = 'member',
  NON_MEMBER = 'non-member',
}
